module.exports = __webpack_public_path__ + "img/suess.3c58ea79.png";